import { TZDate } from "@date-fns/tz";
import { addDays } from "date-fns";

import getDeviceTimeZone from "$src/core/utils/date/get-device-time-zone";

const DEFAULT_HOUR = 12;

type RelativeDateRangeItem = {
  offset: number;
  date: TZDate;
};

type BuildRelativeDateRangeParams = {
  daysBefore: number;
  daysAfter: number;
  timeZone?: string;
  now?: Date;
};

const buildRelativeDateRange = ({
  daysBefore,
  daysAfter,
  timeZone = getDeviceTimeZone(),
  now = new Date(),
}: BuildRelativeDateRangeParams): RelativeDateRangeItem[] => {
  const before = Math.max(0, Math.floor(daysBefore));
  const after = Math.max(0, Math.floor(daysAfter));

  const referenceDate = new TZDate(now, timeZone);
  referenceDate.setHours(DEFAULT_HOUR, 0, 0, 0);

  const items: RelativeDateRangeItem[] = [];

  const startOffset = before > 0 ? -before : 0;

  for (let offset = startOffset; offset <= after; offset += 1) {
    items.push({
      offset,
      date: addDays(referenceDate, offset),
    });
  }

  return items;
};

export default buildRelativeDateRange;
